module.exports = __webpack_public_path__ + "482b86ff281efbf17a5cdc1b447c6b86.svg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors/bloomberg.svg
 ** module id = 375
 ** module chunks = 0
 **/